import { render, staticRenderFns } from "./Landing.html?vue&type=template&id=6b05cd74&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./Landing.scss?vue&type=style&index=0&id=6b05cd74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b05cd74",
  null
  
)

export default component.exports